<template>
<div class="d-flex w-auto p-0 m-0">
	<!-- Previous year button -->
	<div class="m-0 g-0 p-0 me-2">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0 me-2"
			@click="readPreviousYear"
			:disabled="isRequestActive"
		>
			<button-icon icon="triangle-left" fill="currentColor" />
		</button>
	</div>
	<!-- Year input field -->
	<div class="m-0 g-0 p-0 me-2">
		<input
			v-model="inputYear"
			type="text"
			class="form-control form-control-sm no-arrow"
			style="width: 7ch; text-align: center;"
			inputmode="numeric"
			pattern="[0-9]*"
			:readonly="isReadonlyInput"
			:disabled="isRequestActive"
			@input="sanitizeInputYear"
			@keyup.enter="commitInputYear"
			@blur="resetInputYear"
		/>
	</div>
	<!-- Next year button -->
	<div class="m-0 g-0 p-0 me-2">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm mx-1 ms-2"
			@click="readNextYear"
			:disabled="year >= maxYear || isRequestActive"
		>
			<button-icon icon="triangle-right" fill="currentColor" />
		</button>
	</div>
	<div class="m-0 g-0 p-0 ms-2 me-2">
		<div
			v-show="isRequestActive"
			class="spinner-border text-secondary"
			role="status"
			style="width: 1.7rem; height: 1.7rem;"
		>
			<span class="visually-hidden">Loading...</span>
		</div>
	</div>
</div>
</template>

<script>
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'

export default {
	components: {
		ButtonIcon,
	},

	props: {
		year: {
			type: Number,
			required: true,
		},

		isRequestActive: {
			type: Boolean,
			default: false,
		},

		isReadonlyInput: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['update:year'],

	data() {
		return {
			inputYear: String(this.year),
		}
	},

	watch: {
		year(newValue) {
			this.inputYear = String(newValue)
		},
	},

	computed: {
		maxYear() {
			return (new Date()).getFullYear()
		},
	},

	methods: {
		readPreviousYear() {
			this.$emit('update:year', this.year - 1)
		},

		readNextYear() {
			if (this.year < this.maxYear) {
				this.$emit('update:year', this.year + 1)
			}
		},

		commitInputYear() {
			if (this.isReadonlyInput) {
				return
			}

			if (this.inputYear === '') {
				this.resetInputYear()
				return
			}

			const parsedYear = Number(this.inputYear)

			if (!Number.isInteger(parsedYear)) {
				this.resetInputYear()
				return
			}

			this.$emit('update:year', parsedYear)
		},

		sanitizeInputYear() {
			this.inputYear = String(this.inputYear).replace(/\D+/g, '')
		},

		resetInputYear() {
			this.inputYear = String(this.year)
		},
	},
}
</script>

<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}
</style>
